<template>
    <div class="index">

        <div class="star-index">

            <div class="star-nav ">

                <span class="pointer" @click="openIndex">热门明星</span>

                <span> / </span>

                <span>{{ params.name }}</span>

            </div>

            <div class="star-post cf">

                <v-image class="background_img fl" :src="star.background_img"/>

                <div class="fr star-info relative">

                    <star-avatar-item
                        class="absolute star-info-box"
                        :width="160"
                        :height="160"
                        :data="star"
                        :margin-bottom="36"
                        :font-size="28"
                    />

                </div>

            </div>

            <div class="star-content cf">

                <div class="star-left fl">

                    <div class="star-left-title">

                        <img class="fl" src="./images/star_icon_label@2x.png" />

                        <span class="fl">明星简介</span>

                    </div>

                    <div class="star-left-content v-html" v-html="star.content"></div>

                    <div class="star-list">

                        <div class="star-tab">

                            <div
                                class="star-tab-item"
                                v-for="(item,index) in tabs"
                                :key="'star-tab-item-'+index"
                                :class="{'star-tab-item-active': selected == index}"
                                @click="changeTab(item,index)"
                            >{{ item.label }}</div>

                        </div>

                        <div
                            v-if="selected == 0"
                            class="star-tab-list"
                        >

                            <layout-list-item
                                :type="selected"
                                v-for="(item,index) in star.article.list"
                                :key="'star-news-'+index"
                                :data="item"
                            />

                            <div v-if="star.article.list && star.article.list.length <= 0" class="empty">

                                暂无数据

                            </div>

                        </div>

                        <div v-if="selected == 1" class="star-tab-list">

                            <layout-list-item
                                :type="selected"
                                v-for="(item,index) in star.topic.list"
                                :key="'star-topic-'+index"
                                :data="item"
                            />

                            <div v-if="star.topic.list && star.topic.list.length <= 0" class="empty">

                                暂无数据

                            </div>

                        </div>

                        <div v-if="selected == 2" class="star-tab-list">

                            <layout-list-item
                                :type="selected"
                                v-for="(item,index) in star.activity.list"
                                :key="'star-active-'+index"
                                :data="item"
                            />

                            <div v-if="star.activity.list && star.activity.list.length <= 0" class="empty">

                                暂无数据

                            </div>

                        </div>



                        <!-- 分页器 -->
                        <div v-if="count > 10" class="pagination-box">

                            <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="count"
                                @current-page="changePage"
                            >

                            </el-pagination>

                        </div>

                    </div>

                </div>

                <div class="star-right fr">

                    <layout-right-item :data="info"/>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image';
import StarAvatarItem from '../../layout/starAvatarItem/main';
import LayoutListItem from '../../layout/layout-list-item/main';
import LayoutRightItem from '@/layout/layout-right-list/main';

export default {
    name: "star-detail",
    mixins: [mixin],
    components: {
        StarAvatarItem,
        LayoutListItem,
        LayoutRightItem,
        vImage
    }
}
</script>

<style scoped src="./style.css"></style>
